export enum BOUNDARY_LEVEL {
  PAGE = 'page',
  COMPONENT = 'component',
  WIDGET = 'widget',
  CHART = 'chart',
}
